import React from 'react'
import {connect} from 'react-redux'
import {fromJS} from 'immutable'

import {
  CONVERSATION_TYPES
} from '../shared/config/constants'

import truncateString from '../shared/data/formatters/truncate_string'
import openConversation from '../shared/data/setters/open_conversation'
import predictConversationType from '../shared/data/helpers/predict_conversation_type'

import ProfileImage from '../shared/profile_image'
import UserItemInfo from '../shared/user_item_info'
import UnreadMessageCount from './unread_message_count'
import GroupChatAvatar from '../shared/group_chat_avatar'

class ChatListItem extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.openConversation = this.openConversation.bind(this)
  }

  componentWillMount () {
    if (this.props.conversationType && this.props.item) {
      this.setConversationType(this.props.conversationType, this.props.item)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.conversationType !== nextProps.conversationType && nextProps.item) {
      this.setConversationType(nextProps.conversationType, nextProps.item)
    }
  }

  isConversationVisible (conversationId) {
    const index = this.props.visibleConversations
      .findIndex((conv) => conv.get('conversationId') === conversationId)

    return index >= 0 ? true : false
  }

  setConversationType (conversationType) {
    if (conversationType === CONVERSATION_TYPES.MIXED) conversationType = predictConversationType(this.props.item)

    this.setState({conversationType})
  }

  openConversation () {
    const uid = this.props.currentUserUid || this.props.currentGuestUid
    if (uid && this.props.id && this.state.conversationType !== CONVERSATION_TYPES.GUEST) {
      this.props.openConversation(
        uid, this.props.id,
        this.props.conversationId, this.state.conversationType,
        this.props.viewportType
      )
    }
  }

  renderUnreadMessageCount (uid, conversationId) {
    const isConvVisible = this.isConversationVisible(conversationId)
    const shouldShow = (
      uid && conversationId &&
      this.props.shouldShowUnreadMessageCount &&
      !isConvVisible
    )

    return (
      <div>
        <UnreadMessageCount
          uid={uid}
          conversationId={conversationId}
          shouldShowUnreadMessageCount={shouldShow}/>
      </div>
    )
  }

  renderUserItem (item) {
    return (
      <div className="chat-list-item-wrapper">
        <ProfileImage user={item.toJS()} image={this.props.item.get('profileImage')} hasIndicator={this.props.hasIndicator}/>
        <UserItemInfo user={item.toJS()} className="primary" usernameColor={this.props.usernameColor} ratingEnabled={false} sessionsCountEnabled={false} truncateTo={100} shouldFixLineClamp={true}/>
        {this.renderUnreadMessageCount(this.props.currentUserUid, this.props.conversationId)}
      </div>
    )
  }

  renderExpertItem (item) {
    return (
      <div className="chat-list-item-wrapper">
        <ProfileImage user={item.toJS()} image={this.props.item.get('profileImage')} hasIndicator={this.props.hasIndicator}/>
        <UserItemInfo user={item.toJS()} className="primary" usernameColor={this.props.usernameColor} ratingEnabled={this.props.shouldForceHideRatings ? false : true} sessionsCountEnabled={false} truncateTo={100} shouldFixLineClamp={true}/>
        {this.renderUnreadMessageCount(this.props.currentUserUid, this.props.conversationId)}
      </div>
    )
  }

  renderGroupItem (item) {
    return (
      <div className="chat-list-item-wrapper">
        <div>
          <GroupChatAvatar size={48} initials={item.get('initials')} groupId={item.get('key')}/>
        </div>
        <div className='primary group-chat-name' style={{color: '#212121'}}>
          <h4 className='one-line-text' style={{color: this.props.usernameColor, whiteSpace: 'initial'}}>
            {truncateString(item.get('name'), 100)}
          </h4>
        </div>
        {this.renderUnreadMessageCount(this.props.currentUserUid, item.get('key'))}
      </div>
    )
  }

  renderGuestItem (item) {
    return (
      <div className="chat-list-item-wrapper">
        <ProfileImage user={item.toJS()} hasIndicator={false}/>
        <UserItemInfo user={item.toJS()} className="primary" usernameColor={this.props.usernameColor} ratingEnabled={false} sessionsCountEnabled={false}/>
      </div>
    )
  }

  renderInnerContent () {
    if (this.props.item) {
      const {conversationType: type} = this.state

      if (type === CONVERSATION_TYPES.NORMAL) return this.renderUserItem(this.props.item)
      if (type === CONVERSATION_TYPES.EXPERT) return this.renderExpertItem(this.props.item)
      if (type === CONVERSATION_TYPES.GROUP) return this.renderGroupItem(this.props.item)
      if (type === CONVERSATION_TYPES.GUEST) return this.renderGuestItem(this.props.item)
    }
  }

  render () {
    return (
      <div
        className="chat-list-item"
        style={{backgroundColor: (this.state.isItemHovered ? this.props.itemHoverColor : this.props.background)}}
        onClick={this.openConversation}
        onMouseEnter={() => this.setState({isItemHovered: true})}
        onTouchStart={() => this.setState({isItemHovered: true})}
        onMouseLeave={() => this.setState({isItemHovered: false})}
        onTouchEnd={() => this.setState({isItemHovered: false})}>
        {this.renderInnerContent()}
      </div>
    )
  }
}

ChatListItem.defaultProps = {
  shouldShowUnreadMessageCount: false
}

const mapStateToProps = (state, ownProps) => {
  return {
    conversationId: state.getIn(['conversations', '_refs', ownProps.id, 'conversationId']),
    currentUserUid: state.getIn(['currentUser', 'uid']),
    currentGuestUid: state.getIn(['currentGuest', 'uid']),
    visibleConversations: state.getIn(['conversations', '_stack', 'visibles'], fromJS([])),
    usernameColor: state.getIn(['chatSettings', 'colors', 'chatList', 'username']),
    itemHoverColor: state.getIn(['chatSettings', 'colors', 'chatList', 'itemHoverColor']),
    background: state.getIn(['chatSettings', 'colors', 'chatList', 'background']),
    viewportType: state.getIn(['viewport', 'type'])
  }
}

const mapDispatchToProps = () => {
  return {
    openConversation: openConversation
  }
}

const ChatListItemContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ChatListItem)

export default ChatListItemContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_list_item.js
 **/